import { PRIVATE_USER } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_CS_ALERT_CONFIGURATION = PRIVATE_USER + '/cs-alert-configuration';

